import React, { useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faArrowLeft, faHome, faBoxOpen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido'
import { searchImageUrl } from '../imageUrl';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [cartRefreshKey, setCartRefreshKey] = useState(0);
    const [noteText, setNoteText] = useState('');
    const [name, setName] = useState('');
    const [cedula, setCedula] = useState('');
    const [telefono, setTelefono] = useState('');
    const [codigo, setCodigo] = useState('');
    const [tienda, setTienda] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [metodos, setMetodos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [pagoRecibir, setPagoRecibir] = useState('');
    const [estado, setEstado] = useState(null);
    const [ciudad, setCiudad] = useState('Bucaramanga');
    const [pedidoConfirmado, setPedidoConfirmado] = useState(null);
    const [modalTicketOpen, setModalTicketOpen] = useState(false);
    const [pedidoParaVer, setPedidoParaVer] = useState('');
    let now = new Date();
    // Obtener la diferencia de zona horaria en minutos ((Colombia es GMT-5)
    let offset = -5 * 60; // Colombia  está a GMT-3
    // Ajustar la fecha actual sumando/restando el offset
    let colombiaTime = new Date(now.getTime() + offset * 60 * 1000);
    // Formatear la fecha a 'YYYY-MM-DD HH:MM:SS'
    let createdAt = colombiaTime.toISOString().slice(0, 19).replace('T', ' ');

    const tarifasDomicilio = [
        { ciudad: 'Bucaramanga', valor: 10000 },
        { ciudad: 'Bucaramanga Norte', valor: 15000 },
        { ciudad: 'Bucaramanga Sur', valor: 15000 },
        { ciudad: 'Floridablanca', valor: 15000 },
        { ciudad: 'Piedecuesta', valor: 20000 },
        { ciudad: 'Girón', valor: 18000 },
        { ciudad: 'Otro / consultar', valor: 0, pendiente: true },
    ];

    const tarifaSeleccionada = tarifasDomicilio.find(item => item.ciudad === ciudad) || tarifasDomicilio[0];
    const subtotalPedido = totalPrice;
    const valorDomicilio = deliveryOption === 'delivery' ? Number(tarifaSeleccionada?.valor || 0) : 0;
    const domicilioPendiente = deliveryOption === 'delivery' && tarifaSeleccionada?.pendiente;
    const totalPedido = subtotalPedido + valorDomicilio;
    const formatoMoneda = (valor) => `${moneda} ${Number(valor || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

    const [address, setAddress] = useState('');
    useEffect(() => {
        cargarTienda()
    }, []);
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    useEffect(() => {
        const fetchEstado = async () => {
            try {
                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();
                if (data.error) {
                    console.error(data.error);
                } else {
                    setEstado(data.estado);
                }
            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };

        fetchEstado();
    }, []);
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    items: cartItem.items,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused, cartRefreshKey]);



    function normalizarTexto(texto = '') {
        return texto
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    const cargarMetodos = useCallback(() => {
        fetch(`${baseURL}/metodoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Filtra solo los metodos activos y evita opciones duplicadas en el checkout.
                const metodosActivos = (data.metodos || [])?.filter(metodo => metodo.estado === 'Activo');
                const metodosUnicos = metodosActivos.filter((metodo, index, lista) =>
                    lista.findIndex(item => normalizarTexto(item.tipo) === normalizarTexto(metodo.tipo)) === index
                );
                setMetodos(metodosUnicos);
                console.log(metodosUnicos);
            })
            .catch(error => console.error('Error al cargar datos bancarios:', error));
    }, []);

    const cargarProductos = useCallback(() => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    }, []);

    useEffect(() => {
        cargarMetodos();
        cargarProductos();
    }, [isFocused, cargarMetodos, cargarProductos]);

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const obtenerLinkDePago = (texto = '') => {
        const coincidencia = texto.match(/https?:\/\/[^\s]+/i);
        return coincidencia ? coincidencia[0] : '';
    };

    const metodoSeleccionado = metodos?.find(metodo => metodo.tipo === paymentMethod);
    const linkPagoSeleccionado = obtenerLinkDePago(metodoSeleccionado?.datos || '');
    const esPagoEnLinea = Boolean(linkPagoSeleccionado) || normalizarTexto(paymentMethod).includes('linea');

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    useEffect(() => {
        const syncCart = () => setCartRefreshKey(Date.now());
        const openCartFromAssistant = () => {
            syncCart();
            openModal();
        };

        window.addEventListener('cart:updated', syncCart);
        window.addEventListener('haimpress:open-cart', openCartFromAssistant);

        return () => {
            window.removeEventListener('cart:updated', syncCart);
            window.removeEventListener('haimpress:open-cart', openCartFromAssistant);
        };
    }, []);

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const handleWhatsappMessage = (data) => {
        const { idPedido, nombre, cedula, telefono, entrega, ciudad, pago, codigo, total, subtotal, valorDomicilio, nota, productos, pagoRecibir, linkPago, pagoEnLinea } = data;

        const formattedTotalPrice = total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const formattedSubtotal = subtotal?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const formattedDomicilio = valorDomicilio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const phoneNumber = `${tienda[0]?.telefono}`;

        // Formatear los detalles de los productos
        const productosDetails = productos.map(item => {
            const itemsTexto = Array.isArray(item.items) ? item.items.join(', ') : (item.items || '');
            return `\n- *${item.titulo}*\n  Precio: ${moneda} ${item?.precio?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} x ${item.cantidad}\n  ${itemsTexto}\n`;
        }).join('');

        const estadoPago = pagoEnLinea
            ? `Pendiente de confirmacion. Despues de pagar, envio captura o confirmo mi pago con el pedido No. ${idPedido}.`
            : (pagoRecibir === 'Si' ? 'Pago al recibirlo' : 'Pendiente de confirmacion');

        const instruccionesPago = pagoEnLinea
            ? `\nLink de pago: ${linkPago || 'Solicitar link al negocio'}\nPor favor confirmar este pago con captura usando el pedido No. ${idPedido}.`
            : '';

        const domicilioTexto = ciudad
            ? `\nCiudad: ${ciudad}\nDomicilio: ${Number(valorDomicilio || 0) > 0 ? `${moneda} ${formattedDomicilio}` : 'Por confirmar'}`
            : '';

        const message = `Hola! Mi pedido es el No. ${idPedido}\n${productosDetails}\nNombre: ${nombre}\nCedula: ${cedula || 'No registrada'}\nTelefono: ${telefono}\nEntrega: ${entrega}${domicilioTexto}\nForma de pago: ${pago}\nEstado del pago: ${estadoPago}${instruccionesPago}\nCodigo de descuento: ${codigo || 'No aplica'}\nNota: ${nota || 'Sin nota'}\n\nSubtotal: ${moneda} ${formattedSubtotal}\nTotal: ${moneda} ${formattedTotalPrice}\nGracias por su pedido mano.`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');

        // Limpiar estados (opcional, dependiendo de tu lógica)
        setModalTicketOpen(false);
        setName('');
        setCedula('');
        setTelefono('');
        setAddress('');
        setCiudad('Bucaramanga');
        setNoteText('');
        setCodigo('');
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };





    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            if (!name || !cedula || !telefono || !paymentMethod) {
                setMensaje('');
                Swal.fire('Faltan datos', 'Por favor completa nombre, cedula, WhatsApp y forma de pago.', 'warning');
                return;
            }

            if (deliveryOption === 'delivery' && (!address || !ciudad)) {
                setMensaje('');
                Swal.fire('Falta la entrega', 'Por favor completa direccion y ciudad para calcular el domicilio.', 'warning');
                return;
            }

            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    idProducto: item?.idProducto,
                    idCategoria: item.idCategoria,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    items: item?.items,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)
                };
            });

            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);

            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item?.precio * item?.cantidad;
            });
            const subtotalCalculado = totalPrice;
            const domicilioCalculado = deliveryOption === 'delivery' ? Number(tarifaSeleccionada?.valor || 0) : 0;
            const totalCalculado = subtotalCalculado + domicilioCalculado;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();
            formData.append('productos', productosPedidoJSON);
            formData.append('subtotal', subtotalCalculado);
            formData.append('valorDomicilio', domicilioCalculado);
            formData.append('total', totalCalculado);
            formData.append('nombre', name);
            formData.append('cedula', cedula);
            formData.append('telefono', telefono);

            const entrega = deliveryOption === 'delivery' ? address : deliveryOption === 'digital' ? 'Envio Digital/Online' : 'Retiro en Sucursal';
            formData.append('entrega', entrega);
            formData.append('ciudad', deliveryOption === 'delivery' ? ciudad : '');
            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            formData.append('pagado', 'No');
            formData.append('pagoRecibir', pagoRecibir);
            formData.append('createdAt', createdAt);

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.idPedido) {
                setMensaje('');
                const datosPedido = {
                    ...data,
                    productos: productosPedido,
                    subtotal: Number(data.subtotal ?? subtotalCalculado),
                    valorDomicilio: Number(data.valorDomicilio ?? domicilioCalculado),
                    total: Number(data.total ?? totalCalculado),
                    cedula,
                    ciudad: deliveryOption === 'delivery' ? ciudad : '',
                    entrega,
                    linkPago: linkPagoSeleccionado,
                    pagoEnLinea: esPagoEnLinea,
                };

                localStorage.setItem('idPedido', data.idPedido);
                if (data.tokenConsulta) {
                    localStorage.setItem(`pedidoConsultaToken:${data.idPedido}`, data.tokenConsulta);
                }
                setPedidoConfirmado(datosPedido);
                setModalTicketOpen(true);
                closeModal();
                closeModal2();
                clearCart();
            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );
        }
    };

    useEffect(() => {
        if (metodos && metodos.length > 0) {
            const primerMetodo = metodos[0].tipo;
            const primerMetodoTieneLink = Boolean(obtenerLinkDePago(metodos[0]?.datos || ''));
            setPaymentMethod(primerMetodo);
            setPagoRecibir(normalizarTexto(primerMetodo).includes('linea') || primerMetodoTieneLink ? 'No' : '');
        }
    }, [metodos]);

    const handlePaymentChange = (metodo) => {
        const metodoTieneLink = Boolean(obtenerLinkDePago(metodos?.find(item => item.tipo === metodo)?.datos || ''));
        setPaymentMethod(metodo);
        if (normalizarTexto(metodo).includes('linea') || metodoTieneLink) {
            setPagoRecibir('No');
        } else if (metodo === 'Transferencia') {
            setPagoRecibir('Si'); // Valor predeterminado "Sí" para Transferencia
        } else {
            setPagoRecibir(''); // Borra el valor si no es Transferencia
        }
    };
    const handlePagoRecibirChange = (value) => {
        setPagoRecibir(value);
    };

    // 3. Lógica para el modal de WhatsApp
    const verPedidoConfirmado = () => {
        if (!pedidoConfirmado?.idPedido) return;

        setModalTicketOpen(false);
        setPedidoParaVer('');
        setTimeout(() => setPedidoParaVer(String(pedidoConfirmado.idPedido)), 0);
    };

    return (
        <div>
            <ToastContainer />
            <MiPedido autoOpenPedidoId={pedidoParaVer} triggerLabel={null} />
            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            {/* --- BARRA DE NAVEGACIÓN INFERIOR ACTUALIZADA --- */}
            {/* 2. Se reorganizaron los 4 elementos restantes */}
            <div className="bottom-nav-bar">
                <Anchor to="/" className="nav-item">
                    <FontAwesomeIcon icon={faHome} size="lg" />
                    <span>Inicio</span>
                </Anchor>
                <button onClick={openModal} className="nav-item cart-item">
                    <FontAwesomeIcon icon={faShoppingCart} size="lg" />
                    {cartItems?.length >= 1 && <div className="cart-counter">{cartItems.length}</div>}
                    <span>Carrito</span>
                </button>

                <Anchor to="/productos" className="nav-item">
                    <FontAwesomeIcon icon={faBoxOpen} size="lg" />
                    <span>Productos</span>
                </Anchor>
            </div>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <MiPedido />
                </div>


                {
                    estado === 'Abierto' ? (
                        <>
                            {cartItems?.length === 0 ?
                                (<p className='nohay'> No hay productos</p>)
                                : (<>
                                    <div className="modal-content-cart">


                                        {loading ? (
                                            <p>Cargando...</p>
                                        ) : (
                                            <div>

                                                {cartItems.map((item, index) => (
                                                    <div key={item?.idProducto} className='cardProductCart' >
                                                        <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                            <img src={searchImageUrl(obtenerImagen(item))} alt="imagen" loading="lazy" decoding="async" />
                                                        </Anchor>
                                                        <div className='cardProductCartText'>
                                                            <h3>{item.titulo}</h3>
                                                            <span>
                                                                {item?.items?.map((sabor, index) => (
                                                                    <span key={index}>{sabor}, </span>
                                                                ))}
                                                            </span>
                                                            <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                                        </div>
                                                        <div className='deColumn'>
                                                            <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                            <div className='deFlexCantidad'>
                                                                <button onClick={() => decreaseQuantity(index)}>-</button>
                                                                <span>{item.cantidad}</span>
                                                                <button onClick={() => increaseQuantity(index)}>+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='deColumnCart'>
                                        <h4>Total: {moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>
                                        <div className='deFLexBtns'>
                                                <button className='btnWpp' onClick={openModal2}>
                                                    Finalizar pedido
                                                </button>
                                        </div>
                                    </div>

                                    <Modal
                                        isOpen={modalIsOpen2}
                                        onRequestClose={closeModal2}
                                        className="modal-cart"
                                        overlayClassName="overlay-cart"
                                    >
                                        <div className='deFLex'>
                                            <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                            <h4>(*) Campos obligatorios</h4>
                                        </div>
                                        <div className="modal-send-form">
                                            <input
                                                type="text"
                                                id="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder='Apellido y Nombre (*)'
                                            />

                                            <input
                                                type="number"
                                                id="cedula"
                                                value={cedula}
                                                onChange={(e) => setCedula(e.target.value)}
                                                placeholder='Cedula (*)'
                                            />

                                            <input
                                                type="number"
                                                id="telefono"
                                                value={telefono}
                                                onChange={(e) => setTelefono(e.target.value)}
                                                placeholder='Telefono / WathsApp (*)'
                                            />
                                            <div className='deFLexRadio'>
                                                <label>Opciones de entrega (*)</label>

                                                <div
                                                    onClick={() => setDeliveryOption('delivery')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="delivery"
                                                        name="deliveryOption"
                                                        value="delivery"
                                                        checked={deliveryOption === 'delivery'}
                                                        onChange={() => setDeliveryOption('delivery')}
                                                    />
                                                    <label htmlFor="delivery">Envío a domicilio</label>
                                                </div>

                                                <div
                                                    onClick={() => setDeliveryOption('pickup')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="pickup"
                                                        name="deliveryOption"
                                                        value="pickup"
                                                        checked={deliveryOption === 'pickup'}
                                                        onChange={() => setDeliveryOption('pickup')}
                                                    />
                                                    <label htmlFor="pickup">Retiro en Sucursal</label>
                                                </div>

                                                <div
                                                    onClick={() => setDeliveryOption('digital')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="digital"
                                                        name="deliveryOption"
                                                        value="digital"
                                                        checked={deliveryOption === 'digital'}
                                                        onChange={() => setDeliveryOption('digital')}
                                                    />
                                                    <label htmlFor="digital">Envío Digital/Online</label>
                                                </div>


                                            </div>
                                            {deliveryOption === 'delivery' && (

                                                <input
                                                    type="text"
                                                    id="address"
                                                    name="address"
                                                    value={address}
                                                    onChange={(e) => setAddress(e.target.value)}
                                                    placeholder="Dirección / Nro. (*)"
                                                />

                                            )}
                                            {deliveryOption === 'delivery' && (
                                                <div className='deliveryCityBox'>
                                                    <label>Ciudad / sector (*)</label>
                                                    <select value={ciudad} onChange={(e) => setCiudad(e.target.value)}>
                                                        {tarifasDomicilio.map(item => (
                                                            <option value={item.ciudad} key={item.ciudad}>
                                                                {item.ciudad}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className='orderMiniTicket'>
                                                        <div>
                                                            <span>Subtotal productos</span>
                                                            <strong>{formatoMoneda(subtotalPedido)}</strong>
                                                        </div>
                                                        <div>
                                                            <span>Domicilio {ciudad}</span>
                                                            <strong>{domicilioPendiente ? 'Por confirmar' : formatoMoneda(valorDomicilio)}</strong>
                                                        </div>
                                                        <div className='orderMiniTicketTotal'>
                                                            <span>Total estimado</span>
                                                            <strong>{domicilioPendiente ? `${formatoMoneda(subtotalPedido)} + domicilio` : formatoMoneda(totalPedido)}</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className='deFLexRadio'>
                                                <label>Formas de pago (*)</label>
                                                {metodos?.map(metodo => (
                                                    <section key={metodo.idMetodo} className='columnRadio'>
                                                        <div>
                                                            <input
                                                                type="radio"
                                                                name="paymentMethod"
                                                                id={metodo.tipo}
                                                                value={metodo.tipo}
                                                                checked={paymentMethod === metodo.tipo}
                                                                onChange={() => handlePaymentChange(metodo.tipo)}
                                                            />
                                                            <label htmlFor={metodo.tipo}>{metodo.tipo}</label>
                                                        </div>

                                                        {paymentMethod === 'Transferencia' && metodo.tipo === 'Transferencia' && (
                                                            <section className='radioRecibi'>
                                                                <label htmlFor="">Pago al recibirlo</label>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="Sí"
                                                                        value="Si"
                                                                        checked={pagoRecibir === 'Si'}
                                                                        onChange={() => handlePagoRecibirChange('Si')}
                                                                    />
                                                                    <label htmlFor="Sí">Sí</label>
                                                                </div>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="No"
                                                                        value="No"
                                                                        checked={pagoRecibir === 'No'}
                                                                        onChange={() => handlePagoRecibirChange('No')}
                                                                    />
                                                                    <label htmlFor="No">No (envío comprobante)</label>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </section>
                                                ))}


                                            </div>
                                            {esPagoEnLinea && (
                                                <div className='paymentLinkNotice'>
                                                    <strong>Pago pendiente de confirmacion</strong>
                                                    <span>
                                                        Al finalizar se generara tu numero de pedido. Luego enviaremos el pedido por WhatsApp para que confirmes el pago con captura.
                                                    </span>
                                                    {linkPagoSeleccionado && (
                                                        <a href={linkPagoSeleccionado} target="_blank" rel="noreferrer">
                                                            Ver link de pago
                                                        </a>
                                                    )}
                                                </div>
                                            )}
                                            {metodos?.length > 0 && metodos?.some(m => m.tipo === paymentMethod) ? (
                                                <>
                                                    {metodos
                                                        ?.filter(metodo => metodo.tipo === paymentMethod)
                                                        ?.map(datos => (
                                                            < >
                                                                {
                                                                    datos?.datos === '' ? (
                                                                        < >
                                                                        </>

                                                                    ) : (
                                                                        <div className='deFLexRadioMetod' >
                                                                            <span key={datos.idDatos}>
                                                                                {datos.datos}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                }

                                                            </>
                                                        ))}
                                                </>
                                            ) : null}



                                            <input
                                                type="text"
                                                id="codigo"
                                                value={codigo}
                                                onChange={(e) => setCodigo(e.target.value)}
                                                placeholder='Codigo de descuento (opcional)'
                                            />
                                            <textarea
                                                placeholder="Agrega aquí detalles o solicitudes del pedido (Opcional)"
                                                value={noteText}
                                                onChange={(e) => setNoteText(e.target.value)}
                                            />
                                            <fieldset className='deNonefieldset'>
                                                <legend>Productos</legend>
                                                <textarea
                                                    name='productos'
                                                    value={cartItems.map(item => `${item.titulo}, x ${item.cantidad}, ${item.items}, ${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                                    readOnly
                                                />
                                            </fieldset>


                                        </div>
                                        {mensaje ? (
                                            <button type='button' className='btn' disabled>{mensaje}</button>
                                        ) : (
                                            <button type='button' onClick={crearPedido} className='btn'>
                                                Registrar pedido
                                             </button>
                                        )}
                                   </Modal>

                                </>)}
                        </>
                    ) : (
                        <p className='nohay'>El establecimiento se encuentra <br />cerrado en estos momentos. <br />Consulte por horarios de atención.</p>
                    )
                }

            </Modal>
            <Modal
                isOpen={modalTicketOpen}
                className="modal-cart ticketModal"
                overlayClassName="overlay-cart"
                onRequestClose={() => setModalTicketOpen(false)}
            >
                <div className='deFLex'>
                    <button onClick={() => setModalTicketOpen(false)}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <h4>Pedido registrado</h4>
                    <div />
                </div>
                {pedidoConfirmado && (
                    <div className='ticketConfirmContent'>
                        <div className='ticketSuccess'>
                            <span>Pedido No. {pedidoConfirmado.idPedido}</span>
                            <h3>Gracias por su pedido mano</h3>
                            <p>Quedo registrado correctamente. Te contactaremos para confirmar disponibilidad, pago y entrega.</p>
                        </div>

                        <div className='ticketSummaryCard'>
                            {pedidoConfirmado.productos?.map((item, index) => (
                                <div className='ticketProductLine' key={`${item.idProducto}-${index}`}>
                                    <span>{item.titulo} x{item.cantidad}</span>
                                    <strong>{formatoMoneda(Number(item.precio || 0) * Number(item.cantidad || 1))}</strong>
                                </div>
                            ))}
                            <hr />
                            <div className='ticketProductLine'>
                                <span>Subtotal</span>
                                <strong>{formatoMoneda(pedidoConfirmado.subtotal)}</strong>
                            </div>
                            <div className='ticketProductLine'>
                                <span>Domicilio {pedidoConfirmado.ciudad || ''}</span>
                                <strong>{Number(pedidoConfirmado.valorDomicilio || 0) > 0 ? formatoMoneda(pedidoConfirmado.valorDomicilio) : 'Por confirmar'}</strong>
                            </div>
                            <div className='ticketTotalLine'>
                                <span>Total</span>
                                <strong>{formatoMoneda(pedidoConfirmado.total)}</strong>
                            </div>
                        </div>

                        <div className='ticketInfoGrid'>
                            <span>{pedidoConfirmado.nombre}</span>
                            <span>CC {pedidoConfirmado.cedula}</span>
                            <span>{pedidoConfirmado.telefono}</span>
                            <span>{pedidoConfirmado.pago}</span>
                            <span>{pedidoConfirmado.entrega}</span>
                        </div>

                        <div className='ticketActions'>
                            <button type='button' className='btnWpp' onClick={() => handleWhatsappMessage(pedidoConfirmado)}>
                                Enviar copia por WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                            </button>
                            <button type='button' className='btn ticketSecondaryBtn' onClick={verPedidoConfirmado}>
                                Ver mi pedido
                            </button>
                        </div>
                    </div>
                )}
            </Modal>
        </div >
    );
}
